module.exports = __webpack_public_path__ + "img/signbackground.357b383f.png";